import { render, staticRenderFns } from "./Mapa.vue?vue&type=template&id=4faff946&scoped=true&"
import script from "./Mapa.vue?vue&type=script&lang=ts&"
export * from "./Mapa.vue?vue&type=script&lang=ts&"
import style0 from "./Mapa.vue?vue&type=style&index=0&id=4faff946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faff946",
  null
  
)

export default component.exports